<div class="category" (click)="onOpen($event.target)">
  <p>{{ name }}</p>
  <!-- <hyperkit-typography variant="label1" align="left" color="secondary">{{name}}</hyperkit-typography>
  <hyperkit-typography variant="label2" align="right" color="secondary">{{count}}</hyperkit-typography> -->

  <span>{{ count }}</span>
  <i class="k-icon k-font-icon k-i-arrow-chevron-down"></i>
</div>
<div class="category-tags">
  <ul>
    <li *ngFor="let tag of filteredTags">
        <hyperkit-checkbox 
        (click)="onSelect(tag.key)"
        [checked]="isChecked(filterType, tag.key)"
        [value]="tag.key"
        [label]="tag.key"
       >
      </hyperkit-checkbox> 
      <!-- <hyperkit-typography variant="label2" align="right" color="secondary">{{ tag.doc_count }}</hyperkit-typography> -->

      <span>{{ tag.doc_count }}</span>
    </li>
  </ul>
</div>
